import React, { createContext, useContext, useState } from 'react';

const DevModeContext = createContext();

export const useDevMode = () => {
    const context = useContext(DevModeContext);
    if (!context) {
        throw new Error('useDevMode deve ser usado dentro de um DevModeProvider');
    }
    return context;
};

export const DevModeProvider = ({ children }) => {
    const [devMode, setDevMode] = useState(false);

    const toggleDevMode = () => {
        setDevMode(prev => !prev);
    };

    const value = {
        devMode,
        setDevMode,
        toggleDevMode,
        isDevMode: devMode
    };

    return (
        <DevModeContext.Provider value={value}>
            {children}
        </DevModeContext.Provider>
    );
};